import React, { ReactElement, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AlreadySignedUp from './pages/AlreadySignedUp/AlreadySignedUp';

import CreatePassword from './pages/CreatePassword/CreatePassword';
import CreatePasswordSuccess from './pages/CreatePasswordSuccess/CreatePasswordSuccess';
import ExpiredInvite from './pages/ExpiredInvite/ExpiredInvite';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import PublicLoad from './pages/PublicLoad/PublicLoad';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import SignIn from './pages/SignIn/SignIn';
import SignUp from './pages/SignUp/SignUp';

export default function PublicApp(): ReactElement {
  return (
    <Routes>
      <Route path="/aq2es6/signup" element={<SignUp />} />
      <Route path="/aq2es6/signup?token=:inviteToken" element={<SignUp />} />
      <Route path="/expired-invite" element={<ExpiredInvite />} />
      <Route path="/already-signed-up" element={<AlreadySignedUp />} />
      {/*
      // going to redirect signup to marketing site demo page with load balancer
      <Route path="/signup" element={<SignUpPrefinery />} />
      */}
      <Route path="/signin" element={<SignIn />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/create-password/:token" element={<CreatePassword />} />
      <Route path="/create-password/success" element={<CreatePasswordSuccess />} />
      <Route path="/p/:token" element={<PublicLoad />} />
      {/* Default route if path is not found */}
      <Route path="*" element={<Navigate to="/signin" />} />
    </Routes>
  );
}
